import { Button } from "@/components/Button";
import { Modal } from "@/components/Modal";
import { Textarea } from "@/components/Textarea";
import { ProviderConflictList } from "@/pages/Providers/ProviderConflictList";
import { useProviderContext } from "@/pages/Providers/useProviderApi";
import type { ProviderConflict } from "@/pages/Providers/types";

interface ProviderDuplicateDialogProps {
    conflicts: ProviderConflict[];
    observation: string;
    busy: boolean;
    onObservation: (value: string) => void;
    onBack: () => void;
    onCancel: () => void;
    onConfirm: () => void;
    onView: (id: number) => void;
}

export const ProviderDuplicateDialog = ({
    conflicts,
    observation,
    busy,
    onObservation,
    onBack,
    onCancel,
    onConfirm,
    onView,
}: ProviderDuplicateDialogProps) => {
    const { t } = useProviderContext();
    const blocking = conflicts.some(
        (conflict) => conflict.severity === "blocking"
    );
    return (
        <Modal
            isOpen
            maxWidth="3xl"
            onClose={busy ? () => {} : onBack}
            title={t("providers.ui.duplicates_title")}
            footer={
                <div className="flex flex-wrap justify-end gap-2">
                    <Button
                        disabled={busy}
                        variant="secondary"
                        onClick={onCancel}
                    >
                        {t("providers.ui.cancel_operation")}
                    </Button>
                    <Button
                        disabled={busy}
                        variant="secondary"
                        onClick={onBack}
                    >
                        {t("providers.ui.back_form")}
                    </Button>
                    {!blocking && (
                        <Button
                            disabled={busy}
                            variant="primary"
                            onClick={onConfirm}
                        >
                            {t("providers.ui.confirm_continue")}
                        </Button>
                    )}
                </div>
            }
        >
            <div className="flex flex-col gap-4">
                <p className="text-sm">
                    {t(
                        blocking
                            ? "providers.ui.tax_blocked"
                            : "providers.ui.warning_confirmation"
                    )}
                </p>
                <ProviderConflictList conflicts={conflicts} onView={onView} />
                {!blocking && (
                    <Textarea
                        label={t("providers.ui.observation")}
                        aria-label={t("providers.ui.observation")}
                        value={observation}
                        onChange={(event) => onObservation(event.target.value)}
                        maxLength={5000}
                    />
                )}
            </div>
        </Modal>
    );
};
